









import { Component, Vue, Prop } from "vue-property-decorator";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { Action, Getter } from "vuex-class";
import requestService from "@/service/requestService";

@Component({
  components: {
    ConfirmDialog
  }
})
export default class SaveDialog extends Vue {
  $refs!: {
    dialog: ConfirmDialog;
  };
  @Action("clearState", { namespace: "ReservationDetail" })
  clearStateReservation: any;
  @Action("clearState", { namespace: "InspectionDetail" })
  clearStateInsp: any;
  @Action("clearState", { namespace: "SubHeader" })
  clearStateTime: any;

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;

  /** 2021-07-28 sh #6989 implements quick mitsumori(priority 2). [START] */
  @Getter("isCanQuickMitsumori", { namespace: "FunctionSetting"} )
  isCanQuickMitsumori: any;
  /** 2021-07-28 sh #6989 implements quick mitsumori(priority 2). [END] */

  onOpen() {
    this.$refs.dialog.onOpen();
  }

  onSubmit() {
    let reqService = new requestService();
    reqService.clearLiftStaff(this.uketsukeExtendsId);
    this.$emit("onSubmit");
    this.clearStateReservation();
    this.clearStateInsp();
    this.clearStateTime();
    /** 2021-07-28 sh #6989 implements quick mitsumori(priority 2). [START] */
    /** ユーザ画面の操作の場合、予約番号入力画面か、メニュー画面へ行く */
    if (window.location.href.indexOf("user") > -1) {
      if (this.isCanQuickMitsumori) {
        this.$router.push("/user/userMenu");
      } else {
        this.$router.push("/user/reservationnumber");
      }
      return;
    }
    /** 2021-07-28 sh #6989 implements quick mitsumori(priority 2). [END] */
    this.$router.push({ name: "reservation" });
  }

  onClose() {
    this.$emit("onclose");
  }
}
// 保存して終了する　<- save and exit (move to reservation list)
// 保存して継続する　<- save and close
